import React from 'react';

const previewImages = [
  { src: "/portfolio-leo-shirt.jpg", alt: "Saint Laurent Leo" },
  { src: "/portfolio-aesop.jpg", alt: "Aesop Campaign" },
  { src: "/portfolio-bag.jpg", alt: "Luxury Bag", wide: true },
  { src: "/portfolio-gucci-shoe.jpg", alt: "Gucci Shoe" },
  { src: "/portfolio-jilsander.jpg", alt: "Jil Sander" },
];

const HeroPreview = () => {
  return (
    <section data-testid="hero-preview" className="py-6 lg:py-10">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 gap-3 lg:gap-4">
          {previewImages.map((img, i) => (
            <div
              key={i}
              className="overflow-hidden"
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-auto block"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroPreview;
